// Synchronous mirror of the cognitoToken store slice, kept in lockstep by
// whichever call site dispatches setCognitoToken. Needed because provideChatbot's
// config (app.config.ts) is built outside Angular's injector and can't read the
// NgRx store directly.
let cognitoToken: string | null = null;

export function setCognitoTokenHolder(token: string | null): void {
  cognitoToken = token;
}

export function getCognitoTokenHolder(): string | null {
  return cognitoToken;
}
